import { render, staticRenderFns } from "./invoice-template-form.vue?vue&type=template&id=517bd572&scoped=true"
import script from "./invoice-template-form.vue?vue&type=script&lang=ts"
export * from "./invoice-template-form.vue?vue&type=script&lang=ts"
import style0 from "./invoice-template-form.vue?vue&type=style&index=0&id=517bd572&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517bd572",
  null
  
)

export default component.exports